import React, { use, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import useDoor from '../../../hooks/useDoor';
import useTag from '../../../hooks/useTag';
import { resetEditDoor, setSelectedDoor, setShowEditDoorModal } from '../../../slice/editDoorSlice';
import { Button, Modal } from 'react-bootstrap';
import PillLabel from '../../pill-label/PillLabel';
import { loadingWrapper } from '../../../utils/loadingWrapper';
import { setShowDoorHistoryModal, setShowDoorLogsModal } from '../../../slice/showModalSlice';
import { setBody, setOnCancel, setOnConfirm, setShow, setTitle } from '../../../slice/confirmModalSlice';
import { toast } from 'react-toastify';
import { privileges } from '../../../config/role';

const EditDoorModal = ({onSuccess}) => {
    const [doorData, setDoorData] = useState({
      id: null,
      lockTagIds: [],
      name: "",
      customAttributes: {},
    });
    const [doorTagList, setDoorTagList] = useState([]);
    const [isEditEnabled, setIsEditEnabled] = useState(false);

    const show = useSelector((state)=>state.editDoor.showEditDoorModal);
    const selectedDoor = useSelector((state)=>state.editDoor.selectedDoor);
    const userRole = useSelector((state)=> state.user.role);
    const authorized = privileges.editingDoors.includes(userRole);
    const logDoorAuthorized = privileges.logs.includes(userRole);
    const dispatch = useDispatch();
    const { editDoor, doorLoading } = useDoor();
    const { getDoorTags } = useTag();

    const inputValidator = {
        name:doorData.name !== "" && doorData.name.trim().length > 0,
    }
    
    const doorDataCheck = () => {
        return !(inputValidator.name);
    }

    useEffect(()=>{
        if(selectedDoor){
            setDoorData({
                id:selectedDoor.id,
                lockTagIds: selectedDoor.tags.map((tag)=>tag.id),
                name: selectedDoor.name,
                customAttributes: {},
            })
            getTags(false);

        }
    },[selectedDoor]);

    const getTags = (includeDoorTags) => {
        getDoorTags(
            (data)=>{
                setDoorTagList(data?.content || []);
            },
            (error)=>{
                console.log("errore nel ricevere i tag porte",error)
            },
            includeDoorTags
        );
    }
    
    const closeModal = () => {
            setDoorData(
                {
                    id: null,
                    lockTagIds: [],
                    name: "",
                    customAttributes: {},
                }
            );
            setDoorTagList([]);
            setIsEditEnabled(false);
            dispatch(resetEditDoor());

    };

    const cancelEdit = () => {
        setDoorData({
                id:selectedDoor.id,
                lockTagIds: selectedDoor.tags.map((tag)=>tag.id),
                name: selectedDoor.name,
                customAttributes: {},
            })
        setIsEditEnabled(false);
    }

    const editHandler = () => {
        setIsEditEnabled(true);
    }
    
        const addTagToDoor = (tagId) => {
            if(tagId === "") return;
            const id = parseInt(tagId);
            if(doorData.lockTagIds.includes(id)) return;
            setDoorData({...doorData, lockTagIds:[...doorData.lockTagIds, id]});
        }
    
        const removeTagFromDoor = (index) => {
            let newTagList = [...doorData.lockTagIds];
            newTagList.splice(index, 1);
            setDoorData({...doorData, lockTagIds:newTagList});
        }

        //per il change degli input ricordarsi di utilizzare email e username uguali (per comodità)

        const inputHandler = (e) => {
            const { name, value } = e.target;

            setDoorData({ ...doorData, [name]: value });
        }

        const showLogsOpen = () => {
            dispatch(setShowDoorLogsModal());
        }

        const showDoorHistoryOpen = () => {
            dispatch(setShowDoorHistoryModal());
        }

          const openConfirm = () => dispatch(setShow());
        
          const confirmEdit = () => {
            dispatch(setTitle('Conferma Modifica'));
            dispatch(setBody(`Confermi la modifica della Porta ${selectedDoor?.name || ''}?`));
            dispatch(setOnConfirm(() => sendChanges()));
            dispatch(setOnCancel(() => openConfirm()));
            openConfirm();
          };

          const sendChanges = () =>{
            if(!authorized) return;
            editDoor(
                selectedDoor?.id,
                doorData,
                (data)=>{
                    dispatch(setSelectedDoor(data));
                    setIsEditEnabled(false)
                    onSuccess();
                    openConfirm();
                    toast.success("Porta modificata con successo")
                },
                (error)=>{
                    toast.error("Errore nel modificare la porta")
                    openConfirm();
                }
            )
        }

  return (
    <Modal
      show={show}
      size="xl"
      backdrop={isEditEnabled ? 'static' : true}
      onHide={doorLoading ? null : closeModal}
      //fullscreen={true}
      className=''
    >
      <Modal.Header closeButton>
        <Modal.Title className='text-primary-custom'>{isEditEnabled ? 'Modifica Porta' : 'Info Porta'}</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className="d-flex flex-column gap-3">
          <fieldset className="detail-fieldset flex-column gap-2 align-items-center w-100">
            <legend className="detail-legend text-primary-custom">Dati Anagrafici</legend>
            <div className="d-flex gap-2 w-100">
              <div className="d-flex flex-column w-100">
                <p className="m-0">Nome</p>
                <input
                  className={`form-control ${inputValidator.name ? '' : 'is-invalid'}`}
                  type="text"
                  name="name"
                  required
                  disabled={!isEditEnabled}
                  value={doorData.name}
                  onChange={inputHandler}
                />
              </div>
              <div className="d-flex flex-column w-100">
                <p className="m-0">Seriale</p>
                <input
                  className={`form-control`}
                  type="text"
                  name="serialNumber"
                  required
                  disabled={true}
                  value={selectedDoor?.serialNumber}
                />
              </div>
            </div>
            <div className="d-flex w-100">
              <div className="d-flex flex-column w-100">
                <p className="m-0">Modello</p>
                <input
                  className={`form-control`}
                  type="text"
                  name="model"
                  required
                  disabled={true}
                  value={selectedDoor?.model}
                />
              </div>
            </div>
          </fieldset>
          <fieldset className='detail-fieldset flex-column gap-2 align-items-center w-100'>
            <legend className="detail-legend text-primary-custom">Tag</legend>

            <div className='d-flex gap-2 w-100 overflow-x-auto pb-4 pt-2'>
              {doorData.lockTagIds.length > 0 ? (
                doorData.lockTagIds.map((lockTag, index) => {
                    let tag = doorTagList.find((tag)=> tag.id === lockTag);
                    if(!tag) return null;

                  return <PillLabel
                    key={tag.id}
                    name={tag.name}
                    color={tag.color}
                    onClick={isEditEnabled ? () => removeTagFromDoor(index) : undefined}
                  />
                })
              ) : (
                <p className='text-secondary m-0 text-center w-100'>Nessun tag associato</p>
              )}
            </div>
            <div className='d-flex w-100'>
              <div className='d-flex flex-column w-100'>
                <select
                  className='form-select'
                  value={''}
                  onChange={(e) => addTagToDoor(e.target.value)}
                  disabled={!isEditEnabled || doorLoading}
                >
                  <option value={''}>Seleziona un tag</option>
                  {doorTagList.filter((tag)=>!doorData.lockTagIds.includes(tag.id)).map((tag) => (
                    <option key={tag.id} value={tag.id}>
                      {tag.name}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </fieldset>
          {<fieldset className="detail-fieldset gap-2 justify-content-center">
            <legend className="detail-legend text-primary-custom">Azioni</legend>
            {!isEditEnabled ? (
              <>
                {authorized&&<Button variant="danger" onClick={doorLoading? null :editHandler}>
                  Modifica
                </Button>}

                {logDoorAuthorized && <Button className='btn-green' disabled={doorLoading} onClick={showLogsOpen}>
                  {loadingWrapper(doorLoading, <>Realtime</>)}
                </Button>}

                {logDoorAuthorized && <Button className="btn-green" disabled={false} onClick={showDoorHistoryOpen}>
                  {loadingWrapper(doorLoading, <>Storico</>)}
                </Button>}
              </>
            ) : (
              <>
                <Button variant="secondary" onClick={cancelEdit} disabled={doorLoading}>
                  Annulla
                </Button>
                <Button disabled={doorDataCheck() || doorLoading} className='btn-green' onClick={confirmEdit}>
                  {loadingWrapper(doorLoading, <>Conferma</>)}
                </Button>
              </>
            )}
          </fieldset>}
        </div>
      </Modal.Body>
    </Modal>
    
  )
}

export default EditDoorModal